<div class="evidence" *ngIf="submitted">
    <div class="evidence__overview">

        <div class="evidence__overview__documents-container">
            <span class="evidence__overview__documents-header">{{ evidenceDocuments.document_omschrijving }}</span>
            <div class="evidence__overview__preview" *ngFor="let item of evidenceDocuments.document">
                <div class="evidence__overview__preview-container upload-form__preview-container--text">
                    <p class="evidence__overview__preview-item">{{ item.pg_document_bestandsnaam }}</p>
                </div>
                <div class="evidence__overview__preview-container">
                    <div>
                        <svg class="evidence__overview__preview-item svg-icon svg-icon--s">
                            <use href="assets/icons-ui.svg#check-closed"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="evidence" *ngIf="!submitted">
    <div class="evidence__overview">
        <div class="evidence__form">
            <ins-upload-form-container
                class="evidence__upload-form"
                [evidenceIndex]="evidenceIndex"
                [evidenceDocuments]="evidenceDocuments"
            ></ins-upload-form-container>
        </div>
    </div>
</div>

